import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { formatearFecha, formatearHora, calcularDuracionEnMinutos, urlApi } from '../helpers/functionHelpers';
import '../styles/SolicitudesPendientes.css';
import Spinner from './Spinner';
import useProveedores from '../hooks/useProveedores';
import useDropdownData from '../hooks/useDropdownData';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHourglassStart, faHourglassEnd, faClock, faCalendar, faChartGantt, faWarehouse } from '@fortawesome/free-solid-svg-icons';


const DetallesCita = () => {
  const { folio } = useParams();

  const [dataCita, setDataCita] = useState({
    cab_id: '',
    fechaRsv: '',
    dataIni: '',
    dataFin: '',
    AlmacenAsignado_id: '',
    statuses_id: '',
  }); 

  const cargarProveedor = (cita) => {
    setDataCita( prevState => ({
      ...prevState,
      cab_id: cita.cab_id,
      fechaRsv: cita.fechaRsv,
      dataIni: cita.dataIni,
      dataFin: cita.dataFin,
      AlmacenAsignado_id: cita.AlmacenAsignado_id,
      statuses_id: cita.statuses_id
    }));
};

const { proveedores: cita, loading: loadingCita, error: errorCita } = useProveedores(`${urlApi}/api/citasFolio/${folio}`);
const { data: statuses, loading: loadingStatuses } = useDropdownData(`${urlApi}/api/statuses`);
const { data: ubicacions, loading: loadingUbicacions } = useDropdownData(`${urlApi}/api/ubicacions`, setDataCita, dataCita.AlmacenAsignado_id, true);

const obtenerDescripcion = (id, lista) => {
  const item = lista.find((element) => element.id === id);
  return item ? item.descripcion : 'No disponible';
};

const obtenerName = (id, lista) => {
  const item = lista.find((element) => element.id === id);
  return item ? item.name : 'No disponible';
};

useEffect(() => {
  const citaActual = Array.isArray(cita) ? cita[0] : cita;
  if (citaActual) {
    cargarProveedor(citaActual);
  }
}, [cita]);

if (loadingCita || loadingStatuses || loadingUbicacions) {
  return (
    <div className="loader-container">
      <div className="spinner-wrapper">
        <Spinner />
        <p className="loading-text">Cargando datos...</p>
      </div>
    </div>
  );
};

if (errorCita) {
  return <p>La cita aún no ha sido asignada</p>;//Actualizar por un mensaje de error independiente de cada situación
};
  

  return (
    <div className="solicitudes-container">
      <div className="solicitudes-list">
        <div className="solicitud-card">
          <div className="solicitud-details">
            <div className="solicitud-section-row">
              <p><strong><FontAwesomeIcon icon={faCalendar} style={{ marginRight: '8px', color: '#d32f2f' }} />Fecha:</strong> {formatearFecha(dataCita.fechaRsv)}</p>
              <p><strong><FontAwesomeIcon icon={faClock} style={{ marginRight: '8px', color: '#d32f2f' }} />Duración:</strong> {calcularDuracionEnMinutos(formatearHora(dataCita.dataIni), formatearHora(dataCita.dataFin))}</p>
              <p><strong><FontAwesomeIcon icon={faChartGantt} style={{ marginRight: '8px', color: '#d32f2f' }} />Estatus:</strong> {obtenerName(dataCita.statuses_id, statuses)}</p>
            </div>
            <div className="solicitud-section-row">
              <p><strong><FontAwesomeIcon icon={faHourglassStart} style={{ marginRight: '8px', color: '#d32f2f' }} />Hora inicio:</strong> {`${formatearHora(dataCita.dataIni)}`}</p>
              <p><strong><FontAwesomeIcon icon={faHourglassEnd} style={{ marginRight: '8px', color: '#d32f2f' }} />Hora fin:</strong> {`${formatearHora(dataCita.dataFin)}`}</p>
              <p><strong><FontAwesomeIcon icon={faWarehouse} style={{ marginRight: '8px', color: '#d32f2f' }} />Almacén:</strong> {obtenerDescripcion(dataCita.AlmacenAsignado_id, ubicacions)}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetallesCita;
